import React from "react";
import "../css/VisionSection.css";

const VisionSection = () => {
  const visionImg = "/images/I.jpeg";

  return (
    <section className="vision-section-container">
      <div className="vision-content-wrapper">
        {}
        <div className="vision-image-part">
          <div className="vision-dashed-box"></div>
          <img src={visionImg} alt="Our Vision" className="vision-main-img" />
        </div>

        {}
        <div className="vision-text-part">
          <h2 className="vision-title">Our Vision</h2>
          <p className="vision-text-content">
            Sahara Public School upholds the tradition of great respect for
            knowledge and an open spirit of inquiry. The rich vein of excellence
            in learning within the heritage is the foundation of the rigorous
            academic program which is intended to serve the needs of the modern
            world without sacrificing moral and spiritual values. Since the
            faith addresses the complete personality, it is School's philosophy
            that knowledge of the world and practice of our shared beliefs
            should be integrated into a cohesive whole.
          </p>
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
